export default __webpack_public_path__ + "images/613aa454b87d0c0c42ccca0fc3c5b905-screening.svg";